/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MathSumIcon16Light } from './MathSumIcon16Light';
import { MathSumIcon16Regular } from './MathSumIcon16Regular';
import { MathSumIcon16Solid } from './MathSumIcon16Solid';
import { MathSumIcon20Light } from './MathSumIcon20Light';
import { MathSumIcon20Regular } from './MathSumIcon20Regular';
import { MathSumIcon20Solid } from './MathSumIcon20Solid';
import { MathSumIcon24Regular } from './MathSumIcon24Regular';
import { MathSumIcon24Solid } from './MathSumIcon24Solid';
import { MathSumIcon32Regular } from './MathSumIcon32Regular';
import { MathSumIcon64Regular } from './MathSumIcon64Regular';
var sizes = {
    16: {
        light: MathSumIcon16Light,
        regular: MathSumIcon16Regular,
        solid: MathSumIcon16Solid,
    },
    20: {
        light: MathSumIcon20Light,
        regular: MathSumIcon20Regular,
        solid: MathSumIcon20Solid,
    },
    24: {
        regular: MathSumIcon24Regular,
        solid: MathSumIcon24Solid,
    },
    32: {
        regular: MathSumIcon32Regular,
    },
    64: {
        regular: MathSumIcon64Regular,
    },
};
export var MathSumIcon = forwardRef('MathSumIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
